module.exports = __webpack_public_path__ + "9f17b080adcb9bc5b203c4a95e3fe937.png";